module.exports = __webpack_public_path__ + "static/m-JLFuentes-f8f21eaf4fb4d2341d03e63de00031d5.jpg";